export default "__VITE_ASSET__vyF49_tI__"